import React, { useEffect, useState } from 'react';
import axios from 'axios';

function MetaAdmin() {
  const [tenants, setTenants] = useState([]);
  const [loading, setLoading] = useState(true);
  const user = (() => { try { return JSON.parse(localStorage.getItem('user') || '{}'); } catch { return {}; } })();

  useEffect(() => {
    const token = localStorage.getItem('token');
    axios.get('/api/admin/tenants', { headers: { Authorization: `Bearer ${token}` } })
      .then(res => setTenants(res.data))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = '/login';
  };

  return (
    <div className="dashboard">
      <aside className="sidebar">
        <div className="sidebar-brand"><span style={{ color: '#1a1a2e', fontWeight: 'bold' }}>Me</span><span style={{ color: '#d4af37', fontWeight: 'bold' }}>Member</span></div>
        <nav className="sidebar-nav">
          <a href="/meta" className="active">Tenants</a>
        </nav>
        <div style={{ position: 'absolute', bottom: '1.5rem', padding: '0 1.5rem', width: '240px' }}>
          <button onClick={handleLogout} style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.6)', cursor: 'pointer', fontSize: '0.875rem' }}>
            Sign out
          </button>
        </div>
      </aside>

      <main className="main-content">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem' }}>
          <div>
            <h1 style={{ fontSize: '1.5rem', fontWeight: 700, color: 'var(--primary)' }}>Meta Admin</h1>
            <p style={{ color: '#6b7280', fontSize: '0.875rem' }}>Welcome, {user.full_name}</p>
          </div>
        </div>

        <div className="card">
          <h2 style={{ fontSize: '1.1rem', fontWeight: 600, marginBottom: '1rem' }}>All Tenants</h2>
          {loading ? (
            <p style={{ color: '#6b7280' }}>Loading...</p>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.875rem' }}>
              <thead>
                <tr style={{ borderBottom: '2px solid var(--border)' }}>
                  <th style={{ textAlign: 'left', padding: '0.5rem 0.75rem', color: '#6b7280', fontWeight: 600 }}>Name</th>
                  <th style={{ textAlign: 'left', padding: '0.5rem 0.75rem', color: '#6b7280', fontWeight: 600 }}>Slug</th>
                  <th style={{ textAlign: 'left', padding: '0.5rem 0.75rem', color: '#6b7280', fontWeight: 600 }}>Status</th>
                  <th style={{ textAlign: 'left', padding: '0.5rem 0.75rem', color: '#6b7280', fontWeight: 600 }}>Created</th>
                </tr>
              </thead>
              <tbody>
                {tenants.map(t => (
                  <tr key={t.tenant_id} style={{ borderBottom: '1px solid var(--border)' }}>
                    <td style={{ padding: '0.75rem' }}>{t.name}</td>
                    <td style={{ padding: '0.75rem', fontFamily: 'monospace' }}>{t.slug}</td>
                    <td style={{ padding: '0.75rem' }}>
                      <span style={{
                        background: t.is_active ? '#dcfce7' : '#fee2e2',
                        color: t.is_active ? '#15803d' : '#dc2626',
                        padding: '0.2rem 0.6rem', borderRadius: '9999px', fontSize: '0.75rem', fontWeight: 600
                      }}>
                        {t.is_active ? 'Active' : 'Inactive'}
                      </span>
                    </td>
                    <td style={{ padding: '0.75rem', color: '#6b7280' }}>{new Date(t.created_at).toLocaleDateString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </main>
    </div>
  );
}

export default MetaAdmin;
